import '@/services/Sentry/Sentry'
import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.scss'
import App from './App'
import { Provider } from 'react-redux'
import { store, engines } from '@/store'
import { EnginesProvider } from '@/engine/EnginesContext'
import '@/polyfill/history'
import '@/polyfill/segmenter'
import pushyme from '@/services/Pushyme/Pushyme'
import '@/appScript/shareChankFile'
import '@/store/virtualKeyboard/utils'

export type AnyObject = Record<string, any>

pushyme.init()

const root = ReactDOM.createRoot(
  document.getElementById('root')!
)
root.render(
  <Provider store={store}>
    <EnginesProvider value={engines}>
      <App/>
    </EnginesProvider>
  </Provider>
)
